// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPasswordPage_root__3mlSS","logo":"ResetPasswordPage_logo__1jZjA","body":"ResetPasswordPage_body__pjZ0O","form":"ResetPasswordPage_form__2GWkI"};